import { render } from "./CreateGroupView.vue?vue&type=template&id=092cd50e&scoped=true&ts=true"
import script from "./CreateGroupView.vue?vue&type=script&lang=ts"
export * from "./CreateGroupView.vue?vue&type=script&lang=ts"

import "./CreateGroupView.vue?vue&type=style&index=0&id=092cd50e&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-092cd50e"]])

export default __exports__